import { useUser } from "@/app/context/UserContext";
import { getcurrentUser } from "@/app/helpers/functions";
import { iActionRequest } from "@/app/models/interfaceChatBotAction";
import { chatbotSaveAction } from "@/app/services/chatbotsaveaction";
import { useState, useEffect, forwardRef, useRef } from "react";

interface InputChatProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onChangeValue?: (newValue: string) => void;
  actionCode: string;
  debounceDelay?: number;
}

const InputChat = forwardRef<HTMLInputElement, InputChatProps>(
  ({ value = "", onChangeValue, actionCode, debounceDelay = 2000, ...props }, ref) => {
    const { user, userProject,accessType } = useUser();
    const [localValue, setLocalValue] = useState(value);
    const [isDirty, setIsDirty] = useState(false);
    const [isSaving, setIsSaving] = useState(false); // 🔹 Nuevo: controla si ya se está guardando
    const debounceRef = useRef<NodeJS.Timeout | null>(null);

    // Sincroniza cambios externos
    useEffect(() => {
      if (value !== localValue) setLocalValue(value);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = props.type === "checkbox" ? e.target.checked.toString() : e.target.value;
      setLocalValue(val);
      setIsDirty(true);
      if (onChangeValue) onChangeValue(val);
      if (props.onChange) props.onChange(e);

      // Reiniciar debounce
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        triggerSave(val);
      }, debounceDelay);
    };

    // Guarda al salir del campo, cancelando el debounce
    const handleBlur = () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
        debounceRef.current = null;
      }
      triggerSave(localValue.toString());
    };

    const triggerSave = (val: string) => {
      if (!isDirty || isSaving) return; // 🔹 Evita doble envío
      saveAction(val);
    };

    const saveAction = async (val: string) => {
      if (!user?.email || !val?.toString().trim()) return;
      setIsSaving(true);
      try {
        const data = props.name ? { [props.name]: val } : { value: val };
        const formObject = { target: "input", type: props.type, data };
        const request: iActionRequest = {
          company_code: userProject?.project?.company_code ?? "",
          project_id: userProject?.project?.id ?? "",
          //user_id: user.email,
          user_id: getcurrentUser(accessType, userProject, user),
          action_code: actionCode,
          action_detail: formObject,
        };
        await chatbotSaveAction(request);
        setIsDirty(false);
        //console.info("Guardado automático:", val);
      } catch (error) {
        //console.error("Error al guardar:", error);
      } finally {
        setIsSaving(false); // 🔹 Permite futuros guardados
      }
    };

    return (
      <input
        {...props}
        ref={ref}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    );
  }
);

InputChat.displayName = "InputChat";
export default InputChat;
